import { Box } from '@rbilabs/universal-components';

export const MapContainer = Box.withConfig<{ enableMapListExperiment: boolean }>(p => ({
  height: p.enableMapListExperiment ? '1/2' : 'full',
  paddingTop: p.enableMapListExperiment ? '$0' : '$4',
}));
